import { RouteRecordRaw } from 'vue-router';

export const createRoute: RouteRecordRaw = {
  name: 'CreateYourOwnView',
  path: '/create-your-own',
  component: () => import('@/modules/Create/CreateYourOwn.vue'),
  meta: {
    titleLocalizationKey: 'SKILLS.create',
  },
};
